module.exports = __webpack_public_path__ + "static/img/52.b1bbbf2d.jpeg";